import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { AbsoluteRoutingModule } from 'src/app/pipes/absolute-routing/absolute-routing.module';
import { RouterModule } from '@angular/router';
import { ApplyCouponModule } from '../../features/apply-coupon/apply-coupon.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { HeaderModule } from '../header/header.module';



@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    ApplyCouponModule,
    MatBottomSheetModule,
    AbsoluteRoutingModule,
    HeaderModule
  ],
  exports: [FooterComponent]
})
export class FooterModule { }
